const PolishedStoneValue = [
  {
    id: 68,
    reinstatementCode: 1,
    gpText: "Site A Potentially High Risk",
  },
  {
    id: 65,
    reinstatementCode: 1,
    gpText: "Site B Average or Low Risk",
  },
  {
    id: 65,
    reinstatementCode: 2,
    gpText: "Site A Potentially High Risk",
  },
  {
    id: 60,
    reinstatementCode: 2,
    gpText: "Site B Average or Low Risk",
  },
  {
    id: 65,
    reinstatementCode: 3,
    gpText: "Site A Potentially High Risk",
  },
  {
    id: 55,
    reinstatementCode: 3,
    gpText: "Site B Average or Low Risk",
  },
  {
    id: 65,
    reinstatementCode: 4,
    gpText: "Site A Potentially High Risk",
  },
  {
    id: 55,
    reinstatementCode: 4,
    gpText: "Site B Average or Low Risk",
  },
  {
    id: 68,
    reinstatementCode: 5,
    gpText: "Site A Potentially High Risk",
  },
  {
    id: 68,
    reinstatementCode: 5,
    gpText: "Site B Average or Low Risk",
  },
];

export default PolishedStoneValue;
